// import React, { useState } from 'react';

// function Contact() {
//   const [formData, setFormData] = useState({ name: '', email: '', message: '' });
//   const [loading, setLoading] = useState(false);

//   const handleChange = e => {
//     setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
//   };

//   const isValidEmail = email =>
//     /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

//   const handleSubmit = async e => {
//     e.preventDefault();

//     const { name, email, message } = formData;

//     // Basic client-side validation
//     if (!name || !email || !message) {
//       alert('Please fill out all fields.');
//       return;
//     }

//     if (!isValidEmail(email)) {
//       alert('Please enter a valid email address.');
//       return;
//     }

//     setLoading(true);

//     try {
//       const response = await fetch('https://my-backend-app-16zz.onrender.com/send-message', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData),
//       });

//       if (response.ok) {
//         alert('Message sent successfully!');
//         setFormData({ name: '', email: '', message: '' });
//       } else {
//         const errorData = await response.json();
//         alert('Failed to send message: ' + (errorData.error || 'Unknown error'));
//       }
//     } catch (error) {
//       console.error('Error:', error);
//       alert('An error occurred. Please try again later.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <section id="contact" aria-labelledby="contact-label">
//       <div className="contact-content revealable">
//         <h2 id="contact-label">Connect</h2>
//         <h3>Open to full-time roles and strategic engagements in finance, investment analysis, and value-driven decision support.</h3>

//         <form id="contact-form" onSubmit={handleSubmit} aria-label="Contact Form">
//           <div className="form-wrapper">
//             <label htmlFor="name">Name:</label>
//             <input
//               type="text"
//               id="name"
//               name="name"
//               required
//               value={formData.name}
//               onChange={handleChange}
//               disabled={loading}
//             />

//             <label htmlFor="email">Email:</label>
//             <input
//               type="email"
//               id="email"
//               name="email"
//               required
//               value={formData.email}
//               onChange={handleChange}
//               disabled={loading}
//             />

//             <label htmlFor="message">Get in Touch:</label>
//             <textarea
//               id="message"
//               name="message"
//               rows="4"
//               required
//               value={formData.message}
//               onChange={handleChange}
//               disabled={loading}
//             ></textarea>
//           </div>

//           <button type="submit" className="btn-primary" disabled={loading}>
//             {loading ? 'Sending...' : 'Send Message'}
//           </button>
//         </form>
//       </div>
//     </section>
//   );
// }

// export default Contact;

import React, { useState } from "react";

// Backend URL (local vs production)
const BACKEND_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:3000"
    : "https://my-backend-app-16zz.onrender.com";

function Contact() {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const isValidEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { name, email, message } = formData;

    if (!name || !email || !message) {
      alert("Please complete all required fields.");
      return;
    }

    if (!isValidEmail(email)) {
      alert("Please enter a valid email address.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${BACKEND_URL}/send-message`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        alert("Your message has been sent successfully.");
        setFormData({ name: "", email: "", message: "" });
      } else {
        const errorData = await response.json().catch(() => ({}));
        alert(
          errorData.error
            ? `Unable to send message: ${errorData.error}`
            : "Unable to send message. Please try again."
        );
      }
    } catch (error) {
      console.error("Contact form error:", error);
      alert("A connection issue occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" aria-labelledby="contact-label">
      <div className="contact-content revealable">
        <h2 id="contact-label">Connect</h2>
        <h3>
          Open to full-time roles and strategic engagements in finance, investment
          analysis, and value-driven decision support.
        </h3>

        <form id="contact-form" onSubmit={handleSubmit} aria-label="Contact Form">
          <div className="form-wrapper">
            <label htmlFor="name">Name:</label>
            <input
              type="text"
              id="name"
              name="name"
              required
              value={formData.name}
              onChange={handleChange}
              disabled={loading}
            />

            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              name="email"
              required
              value={formData.email}
              onChange={handleChange}
              disabled={loading}
            />

            <label htmlFor="message">Get in Touch:</label>
            <textarea
              id="message"
              name="message"
              rows="4"
              required
              value={formData.message}
              onChange={handleChange}
              disabled={loading}
            ></textarea>
          </div>

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? "Sending..." : "Send Message"}
          </button>
        </form>
      </div>
    </section>
  );
}

export default Contact;


// import React, { useState } from 'react';

// // Auto-detect backend URL
// const BACKEND_URL =
//   window.location.hostname === "localhost"
//     ? "http://localhost:3000"
//     : "https://my-backend-app-16zz.onrender.com";

// function Contact() {
//   const [formData, setFormData] = useState({ name: '', email: '', message: '' });
//   const [loading, setLoading] = useState(false);

//   const handleChange = e => {
//     setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
//   };

//   const isValidEmail = email =>
//     /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

//   // Timeout wrapper to prevent infinite "Sending..."
//   const fetchWithTimeout = (url, options, timeout = 15000) => {
//     return Promise.race([
//       fetch(url, options),
//       new Promise((_, reject) =>
//         setTimeout(() => reject(new Error("Request timed out")), timeout)
//       )
//     ]);
//   };

//   const handleSubmit = async e => {
//     e.preventDefault();

//     const { name, email, message } = formData;

//     if (!name || !email || !message) {
//       alert('Please fill out all fields.');
//       return;
//     }

//     if (!isValidEmail(email)) {
//       alert('Please enter a valid email address.');
//       return;
//     }

//     setLoading(true);

//     try {
//       // Wake up backend
//       await fetch(`${BACKEND_URL}/ping`).catch(() => {});

//       const response = await fetchWithTimeout(
//         `${BACKEND_URL}/send-message`,
//         {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify(formData),
//         }
//       );

//       if (response.ok) {
//         alert('Message sent successfully!');
//         setFormData({ name: '', email: '', message: '' });
//       } else {
//         const errorData = await response.json().catch(() => ({}));
//         alert('Failed to send message: ' + (errorData.error || 'Unknown error'));
//       }
//     } catch (error) {
//       console.error('Error:', error);
//       alert('Request failed or timed out. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <section id="contact" aria-labelledby="contact-label">
//       <div className="contact-content revealable">
//         <h2 id="contact-label">Connect</h2>
//         <h3>Open to full-time roles and strategic engagements in finance, investment analysis, and value-driven decision support.</h3>

//         <form id="contact-form" onSubmit={handleSubmit} aria-label="Contact Form">
//           <div className="form-wrapper">
//             <label htmlFor="name">Name:</label>
//             <input
//               type="text"
//               id="name"
//               name="name"
//               required
//               value={formData.name}
//               onChange={handleChange}
//               disabled={loading}
//             />

//             <label htmlFor="email">Email:</label>
//             <input
//               type="email"
//               id="email"
//               name="email"
//               required
//               value={formData.email}
//               onChange={handleChange}
//               disabled={loading}
//             />

//             <label htmlFor="message">Get in Touch:</label>
//             <textarea
//               id="message"
//               name="message"
//               rows="4"
//               required
//               value={formData.message}
//               onChange={handleChange}
//               disabled={loading}
//             ></textarea>
//           </div>

//           <button type="submit" className="btn-primary" disabled={loading}>
//             {loading ? 'Sending...' : 'Send Message'}
//           </button>
//         </form>
//       </div>
//     </section>
//   );
// }

// export default Contact;
